import { watchEffect as r } from "vue";
import { env as m } from "./index551.js";
function s(e, t, n) {
  m.isServer || r((o) => {
    document.addEventListener(e, t, n), o(() => document.removeEventListener(e, t, n));
  });
}
export {
  s as useDocumentEvent
};
